/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */
 
 import React, { useEffect } from "react";
 import { Redirect, Switch, Route } from "react-router-dom";
 import { shallowEqual, useSelector, useDispatch } from "react-redux";
 import { Layout } from "../_metronic/layout";
 import BasePage from "./BasePage";
 import { Logout, AuthPage } from "./modules/Auth";
 import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
 import { getRefreshToken } from "../app/modules/Auth/_redux/authCrud";
 import * as auth from "../app/modules/Auth/_redux/authRedux";

//  import HtmlPages from "./pages/HtmlPages";
 import HtmlPages from "./modules/HtmlPages/HtmlPages";
  
 export function Routes() {
   const { isAuthorized, refreshToken, expireDate } = useSelector(
     ({ auth }) => ({
       isAuthorized: auth.user != null,
       refreshToken: auth.refreshToken,
       expireDate: auth.expireDate,
     }),
     shallowEqual
   );
  
   const dispatch = useDispatch();
   const { setRefreshToken } = auth.actions;
  
   useEffect(() => {
     const expiresDate = new Date(expireDate);
  
     if (expiresDate <= new Date()) {
       getRefreshToken(refreshToken).then(
         ({ data: { token, expiresAt, refreshToken } }) => {
           dispatch(setRefreshToken(token, expiresAt, refreshToken));
         }
       );
       // .catch(() => dispatch(requestLogout()));
     }
   }, [refreshToken, expireDate, dispatch, setRefreshToken]);
  
   return (
     
     <Switch>
       <Route path="/privacy" component={HtmlPages} />

       {!isAuthorized ? (
         /*Render auth page when user at `/auth` and not authorized.*/
         <Route>
           <AuthPage />
         </Route>
       ) : (
         /*Otherwise redirect to root page (`/`)*/
         <Redirect from="/auth" to="/" />
       )}
  
       <Route path="/error" component={ErrorsPage} />
       <Route path="/logout" component={Logout} />


  
       {!isAuthorized ? (
         /*Redirect to `/auth` when user is not authorized*/
         <Redirect to="/auth/login" />
       ) : (
         <Layout>
           <BasePage />
         </Layout>
       )}
     </Switch>
   );
 }